import { ActiveTabType } from 'data/types';

export const SYSTEM_DESIGN_STAGE_TABS: readonly ActiveTabType[] = [
  'configurations',
  'chooseSystems',
  'accessories',
  'quote'
];

export function isSystemDesignStageTab(activeTab: ActiveTabType): boolean {
  return SYSTEM_DESIGN_STAGE_TABS.includes(activeTab);
}
